import { BaseIllustration, BaseIllustrationProps } from '../BaseIllustration';

export type DocumentsIllustrationProps = Omit<BaseIllustrationProps, 'children'>;

export const DocumentsIllustration = ({ ...props }: DocumentsIllustrationProps) => (
  <BaseIllustration width="64" height="64" viewBox="0 0 64 64" {...props}>
    <g strokeWidth={2} strokeMiterlimit="10" strokeLinecap="square" strokeLinejoin="miter" fill="none">
      <path d="M3 19h42v42H3z" />
      <path d="M11 14v-3h42v42h-3" />
      <path d="M19 6V3h42v42h-3" />
    </g>
  </BaseIllustration>
);

DocumentsIllustration.displayName = 'DocumentsIllustration';
